<template>
    <ul class="switch-tab-container">
        <li :class="[diagramType === 1 ? 'niu1_chose acive' : 'niu1']" @click="routerGo(1)">10kV高压</li>
        <li :class="[diagramType === 2 ? 'niu4_chose acive' : 'niu4']" @click="routerGo(2)">低压</li>
    </ul>
</template>
<script>
export default {
    data() {
        return {};
    },
    props: {
        diagramType: {
            type: [Number, String],
            default: 1
        }
    },
    methods: {
        routerGo(type) {
            this.diagramType = type;

            this.$emit("updateDiagramType", type);
        }
    }
};
</script>
<style lang="scss">
.switch-tab-container {
    position: absolute;
    position: absolute;
    display: inline-flex;
    align-items: center;
    top: -1.2rem;
    left: 43.5%;
    z-index: 999;
    .tab_cssl {
        width: 96%;
        height: 220px;
        //display: none;
        margin: 20px auto 0 auto;
        clear: both;
    }
    li {
        width: 6.65rem;
        height: 2.26rem;
        text-align: center;
        float: left;
        font-size: 0.7rem;
        line-height: 2.26rem;
        background-size: 100% 100%;
        list-style: none;
        font-weight: bold;
        color: #fff;
        cursor: pointer;
        &:hover {
            color: #fecd51;
        }
    }
    .shangit_selected {
        position: relative;
        top: -1px;
        left: 20px;
        float: left;
        border: 1px solid #56fcff;
        width: 80px;
        padding: 8px;
        font-size: 14px;
        border-radius: 5px;
        z-index: 9999;
        color: #fff;
        & > li {
            list-style: none;
            line-height: 25px;
            cursor: pointer;
        }
    }
    .shangit_xiala {
        background-color: rgba(38, 77, 132);
        color: #fecd51;
    }
    .acive {
        color: #fecd51 !important;
    }
    .shangit li i {
        padding-left: 10px;
    }
    .niu1 {
        background: url("../../../assets/image/diagram/taa_01.png") no-repeat;
        background-size: 100% 100%;
    }
    .niu1_chose {
        background: url("../../../assets/image/diagram/tab_01.png") no-repeat;
        background-size: 100% 100%;
    }
    .niu2 {
        background: url("../../../assets/image/diagram/taa_02.png") no-repeat;
        background-size: 100% 100%;
    }
    .niu2_chose {
        background: url("../../../assets/image/diagram/tab_02.png") no-repeat;
        background-size: 100% 100%;
    }
    .niu3 {
        background: url("../../../assets/image/diagram/taa_03.png") no-repeat;
        background-size: 100% 100%;
    }
    .niu3_chose {
        background: url("../../../assets/image/diagram/tab_03.png") no-repeat;
        background-size: 100% 100%;
    }
    .niu4 {
        background: url("../../../assets/image/diagram/taa_04.png") no-repeat;
        background-size: 100% 100%;
    }
    .niu4_chose {
        background: url("../../../assets/image/diagram/tab_04.png") no-repeat;
        background-size: 100% 100%;
    }
}
</style>
